export default "__VITE_ASSET__VHiIcepQ__"